// combatpro/panels/monsters/studio/MonsterStudioPreview.js
//
// Combat PRO - MonsterStudioPreview (Stage 59: Preview Runtime).
//
// The stat-block preview modal (#vi-st-preview-modal), a faithful migration of the
// legacy preview (battletracker.html markup 13182-13195, renderers 11307-11369). It
// renders the currently edited monster read-only in three modes - Standard 5E,
// Printable, and Combat PRO View - with a Print action and a Close action. The mode
// tabs, their order/labels, and the print/close controls match the legacy verbatim.
//
// Data flow: the model is received as a prop straight from the editor runtime; the
// preview keeps no copy. The 5E and Printable modes share one React renderer (the
// Printable mode simply adds the vi-sb-print class, exactly as the legacy passed
// printable=true), driven by the pure buildStatBlockSections derivation; the Combat
// PRO mode renders buildCombatProRows. Nothing here mutates, saves, or fetches; the
// only inputs are the model and the preview runtime handlers. No innerHTML, no DOM
// access. No optional chaining. No em dash.

import React from 'react';
import { buildStatBlockSections, buildCombatProRows } from '../../../monster/monsterStatBlock';

function StatBlockView(props) {
  var s = buildStatBlockSections(props.model);
  var cls = 'vi-sb' + (props.printable ? ' vi-sb-print' : '');
  return (
    <div className={cls}>
      <div className="vi-sb-name">{s.name}</div>
      <div className="vi-sb-sub">{s.sub}</div>
      <hr />
      <p><b>Armour Class</b> {s.ac}</p>
      <p><b>Hit Points</b> {s.hp}</p>
      <p><b>Speed</b> {s.speed}</p>
      <hr />
      <div className="vi-sb-abil">
        {s.abilities.map(function(a) {
          return (
            <div key={a.key}>
              <div className="vi-sb-ab-k">{a.key}</div>
              <div className="vi-sb-ab-v">{a.score} ({a.mod})</div>
            </div>
          );
        })}
      </div>
      <hr />
      {s.meta.map(function(m, i) {
        return <p key={i}><b>{m.label}</b> {m.value}</p>;
      })}
      <hr />
      {s.cards.map(function(sec) {
        return (
          <div className="vi-sb-sec" key={sec.title}>
            <div className="vi-sb-sec-title">{sec.title}</div>
            {sec.entries.map(function(c, i) {
              return (
                <p key={i}>
                  <b>{c.name}.</b> {c.desc}{c.cost ? <>{' '}<i>(Costs {c.cost})</i></> : null}
                </p>
              );
            })}
          </div>
        );
      })}
      {s.spells.length ? (
        <div className="vi-sb-sec">
          <div className="vi-sb-sec-title">Spellcasting</div>
          <p>{s.spells.join(', ')}</p>
        </div>
      ) : null}
    </div>
  );
}

function CombatProView(props) {
  var data = buildCombatProRows(props.model);
  return (
    <div className="vi-cp">
      {data.rows.map(function(r) {
        return (
          <div className="vi-cp-row" key={r.label}>
            <span>{r.label}</span><b>{r.value}</b>
          </div>
        );
      })}
      <div className="vi-cp-note">{data.note}</div>
    </div>
  );
}

var MODES = [
  ['5e', 'Standard 5E'],
  ['printable', 'Printable'],
  ['combatpro', 'Combat PRO View']
];

function MonsterStudioPreview(props) {
  if (!props.open) { return null; }
  var model = props.model || {};
  var mode = props.mode;

  return (
    <div className="vi-enc-modal vi-st-preview-modal" id="vi-st-preview-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="vi-enc-modal-panel vi-st-preview-panel">
        <div className="vi-enc-modal-head">
          <div><div className="vi-enc-modal-title">📄 Stat Block Preview</div></div>
          <button type="button" className="vi-enc-modal-x" onClick={props.onClose}>{'\u00d7'}</button>
        </div>
        <div className="vi-st-pv-modes">
          {MODES.map(function(m) {
            var cls = 'vi-st-pv-mode' + (mode === m[0] ? ' is-active' : '');
            return (
              <button type="button" key={m[0]} className={cls} data-mode={m[0]} onClick={function() { props.onSetMode(m[0]); }}>
                {m[1]}
              </button>
            );
          })}
        </div>
        <div className="vi-enc-modal-body">
          <div id="vi-st-preview-body">
            {mode === 'combatpro'
              ? <CombatProView model={model} />
              : <StatBlockView model={model} printable={mode === 'printable'} />}
          </div>
        </div>
        <div className="vi-enc-modal-actions">
          <button type="button" className="vi-enc-modal-cancel" onClick={function() { props.onPrint(); }}>🖨 Print</button>
          <button type="button" className="vi-enc-modal-cancel" onClick={props.onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default MonsterStudioPreview;
